import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { AnimatePresence, motion } from 'framer-motion';
import JobDetailView from './JobDetailView';
import './JobDetailView.css';

const JobDetailModal = ({
  visible,
  data,
  onClose,
  onReuseParams,
  onEditImage,
  onToggleLike,
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  useEffect(() => {
    if (visible) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => { document.body.style.overflow = prev; };
    }
  }, [visible]);

  useEffect(() => {
    if (!visible) return;
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [visible, onClose]);

  return createPortal(
    <AnimatePresence>
      {visible && data && (
        <>
          {/* Overlay — solid, no backdropFilter */}
          <motion.div
            key="jdm-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.15 }}
            onClick={onClose}
            style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.82)', zIndex: 2000 }}
          />

          {/* Flex centering wrapper — NOT animated, avoids transform conflict */}
          <div
            style={{
              position: 'fixed', inset: 0, zIndex: 2001,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              padding: isMobile ? 0 : 20,
              pointerEvents: 'none',
            }}
          >
            <motion.div
              key="jdm-panel"
              initial={{ opacity: 0, scale: 0.96, y: 16 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.96, y: 8 }}
              transition={{ duration: 0.18, ease: [0.4, 0, 0.2, 1] }}
              style={{
                width: isMobile ? '100%' : 600,
                height: isMobile ? '100%' : undefined,
                maxHeight: isMobile ? '100vh' : '90vh',
                borderRadius: isMobile ? 0 : 16,
                background: '#050505',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                pointerEvents: 'auto',
              }}
            >
              <JobDetailView
                data={data}
                onClose={onClose}
                onReuseParams={onReuseParams}
                onEditImage={onEditImage}
                onToggleLike={onToggleLike}
                isMobile={isMobile}
              />
            </motion.div>
          </div>
        </>
      )}
    </AnimatePresence>,
    document.body
  );
};

export default JobDetailModal;
